import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { STORE_LIST } from '../constants/routes';

const StoreLocationScreen = () => {

  const navigate = useNavigate();

  useEffect(() => {
    navigate(`${STORE_LIST}?view=stores&company=match`);
  }, []);

  return (
    <div>

    </div>
  );
};

export default StoreLocationScreen;
